export var GalleryOptions_Layout_Type;
(function (GalleryOptions_Layout_Type) {
    /** COLLAGE - Collage type */
    GalleryOptions_Layout_Type["COLLAGE"] = "COLLAGE";
    /** MASONRY - Masonry type */
    GalleryOptions_Layout_Type["MASONRY"] = "MASONRY";
    /** GRID - Grid type */
    GalleryOptions_Layout_Type["GRID"] = "GRID";
    /** THUMBNAIL - Thumbnail type */
    GalleryOptions_Layout_Type["THUMBNAIL"] = "THUMBNAIL";
    /** SLIDER - Slider type */
    GalleryOptions_Layout_Type["SLIDER"] = "SLIDER";
    /** SLIDESHOW - Slideshow type */
    GalleryOptions_Layout_Type["SLIDESHOW"] = "SLIDESHOW";
    /** PANORAMA - Panorama type */
    GalleryOptions_Layout_Type["PANORAMA"] = "PANORAMA";
    /** COLUMN - Column type */
    GalleryOptions_Layout_Type["COLUMN"] = "COLUMN";
    /** MAGIC - Magic type */
    GalleryOptions_Layout_Type["MAGIC"] = "MAGIC";
    /** FULLSIZE - Fullsize images type */
    GalleryOptions_Layout_Type["FULLSIZE"] = "FULLSIZE";
    GalleryOptions_Layout_Type["UNRECOGNIZED"] = "UNRECOGNIZED";
})(GalleryOptions_Layout_Type || (GalleryOptions_Layout_Type = {}));
export var GalleryOptions_Layout_Orientation;
(function (GalleryOptions_Layout_Orientation) {
    /** ROWS - Rows Orientation */
    GalleryOptions_Layout_Orientation["ROWS"] = "ROWS";
    /** COLUMNS - Columns Orientation */
    GalleryOptions_Layout_Orientation["COLUMNS"] = "COLUMNS";
    GalleryOptions_Layout_Orientation["UNRECOGNIZED"] = "UNRECOGNIZED";
})(GalleryOptions_Layout_Orientation || (GalleryOptions_Layout_Orientation = {}));
export var GalleryOptions_ItemStyle_Crop;
(function (GalleryOptions_ItemStyle_Crop) {
    /** FILL - Crop to fill */
    GalleryOptions_ItemStyle_Crop["FILL"] = "FILL";
    /** FIT - Crop to fit */
    GalleryOptions_ItemStyle_Crop["FIT"] = "FIT";
    GalleryOptions_ItemStyle_Crop["UNRECOGNIZED"] = "UNRECOGNIZED";
})(GalleryOptions_ItemStyle_Crop || (GalleryOptions_ItemStyle_Crop = {}));
export var GalleryOptions_Thumbnails_Alignment;
(function (GalleryOptions_Thumbnails_Alignment) {
    /** TOP - Top alignment */
    GalleryOptions_Thumbnails_Alignment["TOP"] = "TOP";
    /** RIGHT - Right alignment */
    GalleryOptions_Thumbnails_Alignment["RIGHT"] = "RIGHT";
    /** BOTTOM - Bottom alignment */
    GalleryOptions_Thumbnails_Alignment["BOTTOM"] = "BOTTOM";
    /** LEFT - Left alignment */
    GalleryOptions_Thumbnails_Alignment["LEFT"] = "LEFT";
    /** NONE - No thumbnail */
    GalleryOptions_Thumbnails_Alignment["NONE"] = "NONE";
    GalleryOptions_Thumbnails_Alignment["UNRECOGNIZED"] = "UNRECOGNIZED";
})(GalleryOptions_Thumbnails_Alignment || (GalleryOptions_Thumbnails_Alignment = {}));
//# sourceMappingURL=plugin_gallery.enums.js.map